module.exports = __webpack_public_path__ + "img/6119410.webp";